export default __webpack_public_path__ + "static/media/ahren_cover.1b8833fc.webp";